// index.js

import { createI18n } from 'vue-i18n'
// 引入element-plus多语言
import elementEN from 'element-plus/es/locale/lang/en'
import elementZH from 'element-plus/es/locale/lang/zh-cn'
import elementZHTW from 'element-plus/es/locale/lang/zh-tw'
import elementVI from 'element-plus/es/locale/lang/vi'
// 引入各个模块的语言包
import enLocale from './en'
import zhLocale from './zh'
import zhTWLocale from './zhtw'
import viLocale from './vi'
import { getCookie, setCookie } from '../utils/cookei'

const messages = {
    English: {
        ...elementEN,
        ...enLocale
    },
    Chinese: {
        ...elementZH,
        ...zhLocale
    },
    'zh-TW': {
        ...elementZHTW,
        ...zhTWLocale
    },
    Vietnamese: {
        ...elementVI,
        ...viLocale
    },
}

export const getLocale = () => {
    // 获取缓存
    const storLanguage = getCookie('language')
    // 存在返回当前语言
    const language = navigator.language;
    if (storLanguage) {
        return storLanguage
    }else {
        let lang = ''
        if (language === 'zh-CN') {
            lang = 'Chinese'
        } else if (language === 'zh-TW') {
            lang = 'zh-TW'
        } else if (language === 'en-US' || language == 'en') {
            lang = 'English'
        } else if (language === 'th-TH' || language === 'th') {
            lang = 'Thai'
        } else if (language === 'vi-VN' || language === 'vi') {
            lang = 'Vietnamese'
        } else{
            lang = 'English'
        }
        const requestLang:any = {
            'Chinese': 'zh-Hans',
            'zh-TW': 'zh-Hant',
            'English': 'en',
            'Thai':'th',
            'Vietnamese':'vi'
        }
        setCookie('language', lang, true)
        setCookie('requestLang', requestLang[lang], true)
        // 默认返回简体中文
        return lang
    }   
}
const i18n = createI18n({
  globalInjection: true,
  legacy: false,
  locale: getLocale(),
  messages: messages
})
export default i18n

